module.exports = __webpack_public_path__ + "static/media/HrandPayroll.6f7e60d7.svg";